import { QuestionCircleOutlined } from '@ant-design/icons'
import { Col, Form, Switch, Tooltip } from 'antd'

import { AppAdmin } from 'api/app-admin'
import { usePTOV2Context } from 'context/pto-v2-context-provider'
import { useMarketPlaceAction } from 'hooks/marketplace/use-market-place-action'

const ButtonEnableMarketPlace = ({ edit, form }: { edit: boolean; form: any }) => {
  const contractAddress = form.getFieldValue('contractAddress')

  const { getPTODetail } = usePTOV2Context()

  const { loading, isContractManager, handleEnableMarketPlace } = useMarketPlaceAction({
    contractAddress: contractAddress,
    onChange: async (checked) => {
      form.setFieldValue('marketplaceEnable', checked)
      await AppAdmin.applyTokenizeToMarketPlace({
        contractAddress: contractAddress,
      })
      getPTODetail()
    },
    onError: (checked) => {
      form.setFieldValue('marketplaceEnable', !checked)
    },
  })

  return contractAddress ? (
    <Col span={6}>
      <Form.Item
        label={
          <>
            Marketplace
            <Tooltip
              title={
                <div className="tooltip-box">
                  <p className="tooltip-text">
                    Toggle the switch to manage your PTO . When the switch is <strong>ON</strong>,
                    the is active. When the switch is <strong>OFF</strong>, the is inactive.
                  </p>
                </div>
              }
              placement="right"
            >
              <QuestionCircleOutlined className="tooltip-icon" />
            </Tooltip>
          </>
        }
        shouldUpdate
        required
      >
        {({ getFieldValue }) => (
          <Switch
            checked={getFieldValue('marketplaceEnable')}
            disabled={!edit || !isContractManager || loading}
            onChange={handleEnableMarketPlace}
          />
        )}
      </Form.Item>
    </Col>
  ) : null
}

export default ButtonEnableMarketPlace
